import { render, staticRenderFns } from "./LicenseDetails.vue?vue&type=template&id=0a0c0eec&scoped=true&"
import script from "./LicenseDetails.vue?vue&type=script&lang=ts&"
export * from "./LicenseDetails.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseDetails.vue?vue&type=style&index=0&id=0a0c0eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0c0eec",
  null
  
)

export default component.exports